/**
 * Auth backend base URL. The literal `process.env.PUBLIC_AUTH_API_URL` is
 * replaced with a string at bundle time by Bun's `PUBLIC_*` env-inlining —
 * `[serve.static] env` in bunfig.toml for the dev server, and `env` in
 * build.js for production. The `PUBLIC_` prefix is the inlining allowlist
 * (like Vite's `VITE_`); only literal `process.env.PUBLIC_*` reads are
 * replaced, so do not destructure or alias it. Empty string means same-origin
 * (only applicable if the backend is also serving this SPA).
 */
export function getBackendUrl() {
    return process.env.PUBLIC_AUTH_API_URL || '';
}
